import './index.css';
import './style/general.css';
import './style/fonts/font-import.css';

import App from './App';
import { OuterErrorBoundary } from './shared/error-handlers/boundary-generel';
import { createRoot } from 'react-dom/client';
import { keepServiceWorkerUpdated } from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
    <>
        {/* <React.StrictMode> */}
        <MsalProvider instance={new PublicClientApplication(msalConfig)}>
            <OuterErrorBoundary>
                <App />
            </OuterErrorBoundary>
        </MsalProvider>
        {/* </React.StrictMode> */}
    </>
);

keepServiceWorkerUpdated();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// serviceWorkerRegistration.unregister();
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
